@let clientCode = clientCode$ | async;
@let patientId = patientId$ | async;

<ng-container *transloco="let t">
  @if (!!clientCode && !!patientId) {
    <pxc-sadm-entity-picker
      [autoselection]="true"
      [clientCode]="clientCode"
      [draft]="sadmEntityDraft"
      [isDialog]="false"
      [patientId]="patientId"
      [sadmClientId]="quickModule.sadmClientId"
      (entityCreated)="onSadmEntityCreated($event)"
      (selectionChange)="onSadmEntityPickerSelectionChange($event)" />
  } @else {
    <pxc-loader class="my-6 block">{{ t('Chargement des lésions') }}</pxc-loader>
  }

  <div class="flex justify-between pt-6">
    <button appearance="outline" data-testid="cancel-button" tuiButton type="button" (click)="close()">
      {{ t('Annuler') }}
    </button>
    <button data-testid="confirm-button" tuiButton type="button" [disabled]="!isValid" (click)="validate()">
      {{ t('Valider') }}
    </button>
  </div>
</ng-container>
